import { IWebsiteBuilderNodeBase } from "./websiteBuilderNode";
import { IWebsiteBuilderHeader } from "./section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "./section/websiteBuilderFooter";
import { TWebsiteBuilderMainSection } from "./section/websiteBuilderSection";

export const WEBSITE_BUILDER_ROOT_ID = "root";

export const WEBSITE_BUILDER_ROOT_CLASS_NAME = "website-builder-root";

export interface IWebsiteBuilderRoot extends IWebsiteBuilderNodeBase {
  id: typeof WEBSITE_BUILDER_ROOT_ID;
  type: typeof WEBSITE_BUILDER_ROOT_ID;
  header: IWebsiteBuilderHeader;
  children: TWebsiteBuilderMainSection[];
  footer: IWebsiteBuilderFooter;
}
